<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Registro de integración
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form v-model="integracionForm">
                <v-row>
                  <v-col>
                    <v-select
                      v-model="integracion.fk_idCatMotivoEvaluacion"
                      label="Motivo de la evaluación"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="motivoEvaluacion"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="integracion.fk_idCatTipoEvaluacion"
                      label="Tipo de evaluación"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="tipoEvaluacion"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="menuFechaEvaluacion"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          :value="computedFechaEvaluacion"
                          label="Fecha de evaluación"
                          prepend-icon="mdi-calendar"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="integracion.fechaEvaluacion"
                        @input="menuFechaEvaluacion = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      v-model="menuFechaCertificacion"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          :value="computedFechaCertificacion"
                          label="Fecha de integración"
                          prepend-icon="mdi-calendar"
                          readonly
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="integracion.fechaCertificacion"
                        @input="menuFechaCertificacion = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="integracion.numeroCertificado"
                      label="Número de Certificado"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                    />
                  </v-col>
                  <v-col>
                    <v-file-input
                      v-model="integracion.file"
                      label="Adjuntar CUP"
                      rounded
                      filled
                      background-color="primary"
                      color="secondary"
                      dense
                      prepend-icon="mdi-file"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="integracion.fk_idCatEstatusCertificado"
                      label="Estatus del certificado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="estatusCertificado"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="integracion.fk_idCatResultado"
                      label="Resultado único integral"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="resultado"
                      item-value="id"
                      item-text="title"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="integracion.informeIntegral"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Informe integral"
                      no-resize
                      rows="10"
                    />
                    <v-textarea
                      v-model="integracion.observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones y/o recomendaciones finales"
                      no-resize
                      rows="10"
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="integracion.fk_idCatSemaforoResultado"
                      label="Semáforo de resultado"
                      background-color="primary"
                      color="secondary"
                      rounded
                      filled
                      dense
                      :items="semaforoResultado"
                      item-value="id"
                      item-text="nombre"
                      item-color="secondary"
                      :rules="required"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <v-container>
              <v-row>
                <v-col
                  md="12"
                  align="center"
                >
                  <v-btn
                    rounded
                    class="mx-8"
                    elevation="8"
                    color="secondary"
                    :loading="loading"
                    :disabled="!integracionForm || loading"
                    @click="triggerIntegracion()"
                  >
                    Guardar evaluación
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import { circularProgressProps } from '../../components/props/props';

export default {
  props: {
    idExpediente: {
      type: Number,
      required: true,
    },
    idProgramacion: {
      type: Number,
      required: true,
    },
    idDerivacion: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      circularProgressProps,

      loading: false,
      integracionForm: false,

      menuFechaEvaluacion: false,
      menuFechaCertificacion: false,

      integracion: {
        fk_idDerivacion: this.idDerivacion,
        fk_idProgramacion: this.idProgramacion,
        fk_idExpediente: this.idExpediente,
        fk_idCatResultado: null,
        fk_idCatMotivoEvaluacion: null,
        fk_idCatTipoEvaluacion: null,
        fechaEvaluacion: null,
        numeroCertificado: '',
        fechaCertificacion: null,
        certificado: '',
        observaciones: '',
        fk_idCatEstatusCertificado: null,
        file: null,
        fk_idCatSemaforoResultado: null,
      },

      required: [(v) => !!v || 'Este campo es requerido.'],

      infoEvaluacionForm: false,
      certificadoForm: false,
      personalEdoFuerza: null,
    };
  },

  computed: {
    ...mapGetters('motivoEvaluacion', {
      motivoEvaluacion: 'getMotivoEvaluacion',
    }),
    ...mapGetters('motivoResultado', {
      motivoResultado: 'getMotivoResultado',
    }),
    ...mapGetters('tipoEvaluacion', {
      tipoEvaluacion: 'getTipoEvaluacion',
    }),
    ...mapGetters('estatusCertificado', {
      estatusCertificado: 'getEstatusCertificado',
    }),
    ...mapGetters('resultado', {
      resultado: 'getResultado',
    }),
    ...mapGetters('semaforoResultado', {
      semaforoResultado: 'getSemaforoResultado',
    }),
    ...mapGetters('expediente', {
      cuipSelectedExpediente: 'getCuipSelectedExpediente',
    }),

    computedFechaEvaluacion() {
      return this.integracion.fechaEvaluacion ? moment(this.integracion.fechaEvaluacion).format('DD/MM/YYYY') : '';
    },

    computedFechaCertificacion() {
      return this.integracion.fechaCertificacion ? moment(this.integracion.fechaCertificacion).format('DD/MM/YYYY') : '';
    },
  },

  async mounted() {
    this.SET_PERSONAL_FROM_EXPEDIENTE_ID(this.idExpediente);
    await this.fetchTipoEvaluacion();
    await this.fetchMotivoEvaluacion();
    await this.fetchMotivoResultado();
    await this.fetchEstatusCertificado();
    await this.fetchResultado();
    if (this.cuipSelectedExpediente) {
      const [personal] = await this.searchPersonal(this.cuipSelectedExpediente);
      if (personal) {
        this.personalEdoFuerza = personal;
      }
    } else {
      this.SET_SNACKBAR_MESSAGE('El elemento no cuenta con número de empleado SSC. Su resultado de integración no será sincronizado.');
    }
  },

  methods: {
    ...mapActions('motivoEvaluacion', ['fetchMotivoEvaluacion']),
    ...mapActions('motivoResultado', ['fetchMotivoResultado']),
    ...mapActions('tipoEvaluacion', ['fetchTipoEvaluacion']),
    ...mapActions('estatusCertificado', ['fetchEstatusCertificado']),
    ...mapActions('resultado', ['fetchResultado']),
    ...mapActions('evaluacionesIntegracion', ['saveEvaluacionIntegracion']),
    ...mapActions('personal', ['updatePersonalEdoFuerza', 'searchPersonal']),
    ...mapMutations('expediente', ['SET_PERSONAL_FROM_EXPEDIENTE_ID']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async triggerIntegracion() {
      this.loading = true;

      if (this.integracion.file) {
        this.integracion.certificado = this.integracion.file.name;
      }
      try {
        this.personalEdoFuerza.observacionesC3 = this.getResultadoLabel(this.integracion.fk_idCatResultado);
        await this.updatePersonalEdoFuerza(this.personalEdoFuerza);
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al sincronizar resultado de integración con personal.');
      }
      try {
        await this.saveEvaluacionIntegracion(this.integracion);
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al guardar resultado de integración.');
      }
      this.loading = false;
      this.$router.push('/integracion/personal');
    },

    getResultadoLabel(id) {
      return this.resultado.find((item) => item.id === id).title;
    },
  },
};
</script>
